import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingSpinner from '../shared/LoadingSpinner';
import useAuthRole from '../../hooks/useAuthRole';
import { canAccessScanPortal } from '../../constants/membership';

const UsherScanGuard = ({ children }) => {
  const location = useLocation();
  const { user, role, loading } = useAuthRole();

  if (loading) {
    return <LoadingSpinner message="Checking scan portal access..." />;
  }

  if (!user) {
    return <Navigate to="/conference-scan/login" state={{ from: location }} replace />;
  }

  if (!canAccessScanPortal(role)) {
    return <Navigate to="/conference-scan/login" state={{ denied: true }} replace />;
  }

  return children;
};

export default UsherScanGuard;
